import { render, staticRenderFns } from "./CharityPage.vue?vue&type=template&id=3b7edfd0&"
import script from "./CharityPage.vue?vue&type=script&lang=js&"
export * from "./CharityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports